import React, { useState } from 'react';

const TextInputDuo = ({ 
  label1, 
  label2, 
  placeholder1, 
  placeholder2, 
  value1 = '', 
  value2 = '', 
  onChange,
  number,
  radius = 'sm', // sm, md, lg
  error1 = false,
  error2 = false,
  success1 = false,
  success2 = false,
  disabled = false,
  className = ''
}) => {
  const [localValue1, setLocalValue1] = useState(value1);
  const [localValue2, setLocalValue2] = useState(value2);

  const handleBlur1 = () => {
    if (onChange) {
      onChange({ field1: localValue1, field2: localValue2 });
    }
  };

  const handleBlur2 = () => {
    if (onChange) {
      onChange({ field1: localValue1, field2: localValue2 });
    }
  };

  const getInputClass = (error, success) => {
    let classes = 'wa-text-input-duo__input';
    if (error) classes += ' wa-text-input-duo__input--error';
    if (success) classes += ' wa-text-input-duo__input--success';
    return classes;
  };

  const containerClass = `wa-text-input-duo wa-text-input-duo--radius-${radius} ${className}`;

  return (
    <div className={containerClass}>
      {/* Première ligne */}
      <div className="wa-text-input-duo__row">
        {number && (
          <span className="wa-text-input-duo__number">
            {number}.
          </span>
        )}
        {label1 ? (
          <label className="wa-text-input-duo__label">
            {label1}
          </label>
        ) : (
          <div className="wa-text-input-duo__label--empty"></div>
        )}
        <input
          type="text"
          value={localValue1}
          onChange={(e) => setLocalValue1(e.target.value)}
          onBlur={handleBlur1}
          placeholder={placeholder1}
          disabled={disabled}
          className={getInputClass(error1, success1)}
        />
      </div>
      
      {/* Deuxième ligne */}
      <div className="wa-text-input-duo__row">
        {number && (
          <span className="wa-text-input-duo__number"></span> // Espace pour aligner avec la première ligne
        )}
        {label2 ? (
          <label className="wa-text-input-duo__label">
            {label2}
          </label>
        ) : (
          <div className="wa-text-input-duo__label--empty"></div>
        )}
        <input
          type="text"
          value={localValue2}
          onChange={(e) => setLocalValue2(e.target.value)}
          onBlur={handleBlur2}
          placeholder={placeholder2}
          disabled={disabled}
          className={getInputClass(error2, success2)}
        />
      </div>
    </div>
  );
};

export default TextInputDuo;
